const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://belucky.band/api.php'  // Replace with your actual domain
  : 'http://localhost:3001/api';

export const hiscoresAPI = {
  async submitScore(scoreData) {
    try {
      const url = process.env.NODE_ENV === 'production' 
        ? `${API_BASE_URL}?action=submit`
        : `${API_BASE_URL}/hiscores`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(scoreData),
      });
      
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      return data;
    } catch (error) {
      console.error('Error submitting score:', error);
      throw error;
    }
  },

  async getHighScores(gameMode = null, limit = 100) {
    try {
      const url = process.env.NODE_ENV === 'production' 
        ? `${API_BASE_URL}?action=hiscores&limit=${limit}${gameMode ? `&gameMode=${gameMode}` : ''}`
        : `${API_BASE_URL}/hiscores?limit=${limit}${gameMode ? `&gameMode=${gameMode}` : ''}`;
      
      const response = await fetch(url);
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      return data.scores;
    } catch (error) {
      console.error('Error fetching scores:', error);
      throw error;
    }
  },

  async getPlayerScores(playerName, gameMode = null) {
    try {
      const url = process.env.NODE_ENV === 'production' 
        ? `${API_BASE_URL}?action=player&name=${encodeURIComponent(playerName)}${gameMode ? `&gameMode=${gameMode}` : ''}`
        : `${API_BASE_URL}/hiscores/player/${encodeURIComponent(playerName)}${gameMode ? `?gameMode=${gameMode}` : ''}`;
      
      const response = await fetch(url);
      const data = await response.json();
      
      if (!response.ok) throw new Error(data.error);
      return data;
    } catch (error) {
      console.error('Error fetching player scores:', error);
      throw error;
    }
  }
};